import { isArray, isObject, isString } from '@utils/guards';

import type { IApiErrorField } from '../services/query/types';

// eslint-disable-next-line sonarjs/cognitive-complexity
export default function prepareTranslationValues(errors: unknown): Record<string, IApiErrorField['values']> {
  const result: Record<string, IApiErrorField['values']> = {};

  if (!isObject(errors)) {
    return result;
  }

  for (const [, value] of Object.entries(errors)) {
    const listOfErrors = isObject(value) && 'attribute' in value ? value.attribute : value;

    if (isArray(listOfErrors)) {
      for (const item of listOfErrors) {
        if (isObject(item) && 'locale_key' in item && isString(item.locale_key)) {
          result[item.locale_key] = 'values' in item && isObject<IApiErrorField['values']>(item.values) ? item.values : {};
        }
      }
    }
  }

  return result;
}
